import { Link, useLocation } from "react-router-dom"
import { useTranslations } from "../../layers/Localization"

function BreadCrumbLink({ children, to, ...props }) {
    const { pathname } = useLocation()
    return pathname === to
        ? <div className="text-gray-500 whitespace-nowrap">{children}</div>
        : <Link {...props} to={to} className="text-blue-500 hover:underline min-w-fit whitespace-nowrap">
            {children}
        </Link>
}

export function Breadcrumb() {
    const { pathname } = useLocation()
    const t = useTranslations()

    let paths = pathname.split('/').filter(x => x)
    const toText = path => /[a-f0-9]{10}/.test(path) ? path : t(path[0].toUpperCase() + path.slice(1).replace(/([A-Z])/g, x => ' ' + x).replace(/-/g, ' '))
    const toUrl = index => '/' + paths.slice(0, index + 1).join('/')

    return <div className="flex gap-3 whitespace-nowrap">
        <BreadCrumbLink to="/">{t('Home')}</BreadCrumbLink>
        {paths.map((path, index) => <div key={path} className="contents">
            <div className="text-gray-500">/</div>
            <BreadCrumbLink to={toUrl(index)}>{toText(path)}</BreadCrumbLink>
        </div>)}
    </div>
}